import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import {
  WEBSERVICE,
  handleSendOtpInSms,
  showToast,
  OPTIONS_FOR_FINGERPRINT,
  encryptMessages,
  handleDefaultAssetPair,
} from "../../CoreDataService";
import { useForm } from "react-hook-form";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import PaybitoCaptcha from "../../Custom-component/PaybitoCaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./Login.css";

import Fingerprint2 from "fingerprintjs2";
import Cookies from "js-cookie";

import {
  isMobile,
  isTablet,
  isDesktop,
  browserName,
  browserVersion,
} from "react-device-detect";

import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Link,
  CircularProgress,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  deviceInformation,
  deviceVerification,
  LoginWithUsernamePassword,
} from "../../AllApis/Apis";
import SocialLogin from "./SocialLogin";
import { useChat } from "../../Services/ChatService";
import { useOtp } from "../../Contexts/OtpContext";

export default function Login() {
  const { sendSmartMobileOtp } = useOtp();
  const navigate = useNavigate();
  const location = useLocation();
  const { makeUserOnline } = useChat();

  const [countdown, setCountdown] = useState(300);
  const [deviceDetails, setDeviceDetails] = useState(null);
  const captchaRef = useRef(null);

  const [authOtpModalShow, setAuthOtpModalShow] = useState(false);
  const handleAuthOtpModalClose = () => (
    setAuthOtpModalShow(false), setEmailOtp(""), setPhoneOtp(""), setGaOtp("")
  );
  const handleAuthOtpModalShow = () => setAuthOtpModalShow(true);
  const [passwordVisible, setPasswordVisible] = useState(false);

  // var [loginEmail, setLoginEmail] = useState("");
  // var [loginPassword, setLoginPassword] = useState("");

  var [emailOtp, setEmailOtp] = useState("");
  var [gaOtp, setGaOtp] = useState("");
  var [phoneOtp, setPhoneOtp] = useState("");
  const [copyEmail, setCopyEmail] = useState("");
  const [copyPhoneEmail, setCopyPhoneEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [disableConfirmButton, setDisableConfirmButton] = useState(false);
  const [showGetCodeButtonInSmsOtpPopup, setShowGetCodeButtonInSmsOtpPopup] =
    useState(300);
  const [intervalMessageForSmsPopup, setIntervalMessageForSmsPopup] =
    useState("");

  var [secondStatusCheck, setSecondStatusCheck] = useState(false);
  var [userPhoneUsingForSendingSms, setUserPhoneUsingForSendingSms] =
    useState("");
  var [
    userPhoneCountryCodeUsingForSendingSms,
    setUserPhoneCountryCodeUsingForSendingSms,
  ] = useState("");

  var [isGoogleAuthEnable, setIsGoogleAuthEnable] = useState(false);
  var [isPhoneVerificationEnable, setIsPhoneVerificationEnable] =
    useState(false);

  var [brokerSocialLogin, setBrokerSocialLogin] = useState(false);

  const loginForm = useForm();
  const authForm = useForm();
  const {
    register: loginRegister,
    handleSubmit: loginSubmit,
    watch,
    setValue,
    formState: { errors: loginErrors }, // Rename errors to loginErrors
  } = loginForm;

  const getQueryParam = (key) => {
    return new URLSearchParams(location.search).get(key);
  };

  const {
    register: authRegister,
    handleSubmit: authSubmit,
    formState: { errors: authErrors }, // Rename errors to authErrors
  } = authForm;

  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);
  const [isLoginButtonEnabled, setLoginButtonEnabled] = useState(true);
  const [disableLoginButton, setDisableLoginButton] = useState(false);

  const loginEmail = watch("emailId");
  const loginPassword = watch("password");

  const [resendVerifyButton, setResendVerifyButton] = useState(false);
  const [resendVerifyButtonErrorMessage, setResendVerifyButtonErrorMessage] =
    useState("");

  const [counter, setCounter] = useState(0);
  const [showCounter, setShowCounter] = useState(false);
  const [showUnverifiedMsg, setShowUnverifiedMsg] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [isBrokerLoaded, setIsBrokerLoaded] = useState(false);
  console.log("brokerDetailedInfo", brokerDetailedInfo, brokerBasicInfo);
  console.log("brokerBasicInfo", brokerBasicInfo);

  // localStorage.setItem("brokerId", brokerBasicInfo?.value[0].brokerId);
  // localStorage.setItem("exchange", brokerBasicInfo?.value[0].exchange);

  // You can define your loading condition based on how your state looks

  // ✅ useEffect is called directly at the top level of the component
  useEffect(() => {
    const isLoading =
      !brokerBasicInfo ||
      Object.keys(brokerBasicInfo).length === 0 ||
      !brokerDetailedInfo ||
      Object.keys(brokerDetailedInfo).length === 0;

    setIsBrokerLoaded(!isLoading);

    if (brokerDetailedInfo.socialLogin == 1) {
      setBrokerSocialLogin(true);
    } else {
      setBrokerSocialLogin(false);
    }
  }, [brokerBasicInfo, brokerDetailedInfo]);

  const currentDate = new Date();
  const endTimeRef = useRef(Date.now());
  const timerRef = useRef(null);
  const phoneOtpEndTimeRef = useRef(Date.now());
  const phonetimerRef = useRef(null);

  console.log("showCounter", countdown);

  const startCountdown = () => {
    // Clear any existing interval
    if (timerRef.current) clearInterval(timerRef.current);

    // Reset end time
    endTimeRef.current = Date.now() + 300 * 1000;

    const updateCountdown = () => {
      const remaining = Math.max(
        Math.floor((endTimeRef.current - Date.now()) / 1000),
        0
      );
      setCountdown(remaining);

      if (remaining === 0 && timerRef.current) {
        clearInterval(timerRef.current);
        setSecondStatusCheck(false);
        setCopyEmail("");
      }
    };

    // Run immediately and then every second
    updateCountdown();
    timerRef.current = setInterval(updateCountdown, 1000);
  };

  // When modal shows, start countdown
  useEffect(() => {
    if (copyEmail) {
      startCountdown();
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [copyEmail]);

  const startPhoneOtpCountdown = () => {
    // Clear any existing interval
    if (phonetimerRef.current) clearInterval(phonetimerRef.current);

    // Set end time to 5 minutes (300 sec) from now
    phoneOtpEndTimeRef.current = Date.now() + 300 * 1000;

    const updateCountdown = () => {
      const remaining = Math.max(
        Math.floor((phoneOtpEndTimeRef.current - Date.now()) / 1000),
        0
      );
      setShowGetCodeButtonInSmsOtpPopup(remaining);

      if (remaining === 0 && phonetimerRef.current) {
        clearInterval(phonetimerRef.current);
        setCopyPhoneEmail("");
      }
    };

    // Run immediately
    updateCountdown();

    // Run every second
    phonetimerRef.current = setInterval(updateCountdown, 1000);
  };

  // 🔹 When modal shows, start countdown
  useEffect(() => {
    if (copyPhoneEmail) {
      startPhoneOtpCountdown();
    }

    return () => {
      if (phonetimerRef.current) clearInterval(phonetimerRef.current);
    };
  }, [copyPhoneEmail]);
  useEffect(() => {
    getDeviceDetails();
    // document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const firstParam = getQueryParam("userId");
    const secondParam = getQueryParam("location");
    const thirdParam = getQueryParam("sessionToken");
    const fourthParam = getQueryParam("del");
    const fifthParam = getQueryParam("uuid");
    const sixthParam = getQueryParam("login-for");
    const seventhParam = getQueryParam("broker-id");

    // Store payment invoice data from URL params if callFrom is "payments"
    const callFrom = getQueryParam("callFrom");
    if (callFrom === "payments") {
      const invoicePayData = {
        invoice_id: getQueryParam("invoice_id") || "",
        merchant_id: getQueryParam("merchant_id") || "",
        currency: getQueryParam("currency") || "",
        fiat_amount: getQueryParam("fiat_amount") || "",
        description: getQueryParam("description") || "",
        amount_to_be_paid: getQueryParam("amount_to_be_paid") || "",
        currency_id: getQueryParam("currency_id") || "",
        transaction_address: getQueryParam("transaction_address") || "",
        network: getQueryParam("network") || "",
      };
      localStorage.setItem("callFrom", "payments");
      localStorage.setItem("invoicePayData", JSON.stringify(invoicePayData));
    }

    if (sixthParam) {
      localStorage.setItem("loginFor", sixthParam);
    } else {
      localStorage.removeItem("loginFor");
    }

    if (fifthParam && secondParam && thirdParam && deviceDetails) {
      setTimeout(async () => {
        const storedDeviceId = localStorage.getItem("deviceId");
        const deviceId =
          storedDeviceId && !["null", "undefined", ""].includes(storedDeviceId)
            ? storedDeviceId
            : generateUUID();
        if (!storedDeviceId || ["null", "undefined", ""].includes(storedDeviceId)) {
          localStorage.setItem("deviceId", deviceId);
          Cookies.set("deviceID", deviceId, { expires: 60 });
        }

        const deviceinfoObj = {
          uuid: fifthParam,
          location: secondParam,
          sessionToken: thirdParam,
          latitude: deviceDetails?.latitude,
          longitude: deviceDetails?.longitude,
          ipAddress: deviceDetails?.ip,
          deviceId: deviceId,
          deviceType: isMobile
            ? "mobile"
            : isTablet
            ? "tablet"
            : isDesktop
            ? "Desktop browser"
            : "unknown",
          browser: `${browserName} ${browserVersion}`,
        };

        const response = await deviceVerification(deviceinfoObj);

        if (response?.error?.error_data === 1) {
          setTimeout(() => {
            navigate("/verify");
          }, 1000);
        } else {
          showToast("success", "Device verified successfully");
          localStorage.setItem("uuid", fifthParam);
          localStorage.setItem("access_token", response.token);

          const exchangeTokenExpiry = new Date();
          exchangeTokenExpiry.setMonth(exchangeTokenExpiry.getMonth() + 12);
          document.cookie = `exchange_token=${response.token};expires=${exchangeTokenExpiry};domain=.paybito.com;path=/`;
          setLoginData(response, sixthParam);
        }
      }, 2000);
    }
  }, [location, deviceDetails]);

  useEffect(() => {
    const sixthParam = getQueryParam("login-for");
    const seventhParam = getQueryParam("broker-id");
    const urlEmail = getQueryParam("email");
    setValue("emailId", urlEmail);

    if (sixthParam) {
      if (sixthParam === "nft") {
        const obj = {
          // userId,
          uuid: localStorage.getItem("uuid"),
          token: localStorage.getItem("access_token"),
        };
        const jsonStr = JSON.stringify(obj);
        const encoded = btoa(jsonStr);

        const parsedUrl = new URL(window.location.href);
        const baseUrl = parsedUrl.origin;

        window.location.href = `${baseUrl}/nft-marketplace/session/${encoded}`;
      } else if (sixthParam === "data-deletion") {
        navigate("/settings");
      } else if (sixthParam === "ico-merchant") {
        setTimeout(() => {
          const obj = {
            userId: localStorage.getItem("user_id"),
            uuid: localStorage.getItem("uuid"),
            token: localStorage.getItem("access_token"),
          };
          const jsonStr = JSON.stringify(obj);
          const str = btoa(jsonStr);
          window.location.href = `https://ico-contract-owner.hashcashconsultants.com/session.html?obj=${str}`;
        }, 1000);
      } else if (sixthParam === "appstore" || sixthParam === "app-store") {
        if (localStorage.getItem("access_token") && localStorage.getItem("uuid")) {
          window.location.href = window.location.origin + "/app-store/";
        }
      } else if (sixthParam.startsWith("app-store/") || sixthParam.startsWith("appstore/")) {
        if (localStorage.getItem("access_token") && localStorage.getItem("uuid")) {
          const targetPath = sixthParam.startsWith("app-store/")
            ? sixthParam
            : "app-store/" + sixthParam.substring("appstore/".length);
          window.location.href = window.location.origin + "/" + targetPath;
        }
      }
    }

    if (seventhParam) {
      // this.data.BROKERID = seventhParam
      setTimeout(() => {
        // localStorage.setItem("DEMOBROKERID", seventhParam);
        // console.log("brokerId--> 3", seventhParam);
        // localStorage.setItem("BROKERID", seventhParam);
      }, 500);
    }
  }, [location, navigate]);

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";
  var frontPageNavColor = brokerDetailedInfo?.color?.navbarColor;
  var frontPageButtonColor = brokerDetailedInfo?.color?.buttonColor;

  var backgroundStyle = "";

  if (brokerDetailedInfo?.color?.isBackgroundImage == 0) {
    backgroundStyle = {
      background: frontPagebakgColor,
      // height: `100%`,
    };
  } else {
    backgroundStyle = {
      backgroundImage: `url(${brokerDetailedInfo?.color?.backgroundImageLink})`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `cover`,
      backgroundPosition: `center`,
      minHeight: `100%`,
    };
  }

  const setStateHandler = (newState) => {
    this.setState(newState);
  };

  const onSubmit = async (data) => {
    // openRecaptchaModal();
    console.log("data---->>>", copyEmail, data);
    if (resendVerifyButtonErrorMessage && data.emailId === copyEmail) {
      setAuthOtpModalShow(true);
    } else {
      try {
        const { token } = await captchaRef.current.verify();
        redirectToAuthentication(token, null);
      } catch (err) {
        if (err.message !== "captcha-cancelled") {
          showToast("error", err.message || "Captcha verification failed");
        }
      }
      setResendVerifyButtonErrorMessage("");
    }
  };
  const getDeviceDetails = async () => {
    const response = await deviceInformation();
    setDeviceDetails(response);
  };

  const onAuthModalSubmit = async (data) => {
    if (emailOtp || data == "12345678") {
      if (emailOtp?.length === 8 || data?.length === 8) {
        const payload = {
          deviceId:
            Cookies.get("deviceID") ||
            localStorage.getItem("deviceId") ||
            deviceId,
          deviceType: isMobile
            ? "mobile"
            : isTablet
            ? "tablet"
            : isDesktop
            ? "Desktop browser"
            : "unknown",
          browser: `${browserName} ${browserVersion}`,
          email: loginEmail,
          otp: emailOtp,
          password: loginPassword,
          latitude: deviceDetails?.latitude,
          longitude: deviceDetails?.longitude,
          ipAddress: deviceDetails?.ip,
          location: deviceDetails?.country_name,
          brokerId: localStorage.getItem("BROKERID_Domain"),
        };
        if (isPhoneVerificationEnable) {
          payload["phoneOtp"] = phoneOtp;
        }
        if (isGoogleAuthEnable) {
          payload["securityCode"] = gaOtp;
        }
        setIsLoading(true);
        const response = await LoginWithUsernamePassword(payload);
        if (response?.error.error_data === 0) {
          showToast("success", response?.error.error_msg);
          callFcmTokenRegister(response?.token, response?.userResult?.uuid);
          localStorage.setItem("token", response?.token);
          localStorage.setItem("password", loginPassword);

          const exchangeTokenExpiry = new Date();
          exchangeTokenExpiry.setMonth(exchangeTokenExpiry.getMonth() + 12);
          document.cookie = `exchange_token=${response?.token};expires=${exchangeTokenExpiry};domain=.paybito.com;path=/`;
          localStorage.setItem("uuid", response?.userResult?.uuid);
          localStorage.setItem("userId", response?.userResult?.userId);
          setResendVerifyButtonErrorMessage(() => "");
          handleAuthOtpModalClose();
          makeUserOnline({
            userId: encryptMessages(response?.userResult?.userId),
          });

          // navigate("/");
          setLoginData(response, null);
          setIsLoading(false);

          // window.location.reload();
        } else if (response?.error.error_data === 2) {
          setIsLoading(false);
          setShowUnverifiedMsg(true);
          setResendVerifyButtonErrorMessage(response?.error.error_msg);
          handleAuthOtpModalClose();
        } else if (response?.error.error_data === 1) {
          setIsLoading(false);

          setResendVerifyButtonErrorMessage(response?.error.error_msg);
          handleAuthOtpModalClose();
        } else {
          setIsLoading(false);
          showToast("error", response?.error.error_msg);
        }
      } else {
        showToast("error", "Please enter the full length code");
      }
    } else {
      console.log("email otp issue");
    }
  };

  useEffect(() => {
    generateUUID();

    // if (localStorage.getItem(data.exchange +'secondStatusCheck') == 'true') {
    //   setSecondStatusCheck(true) ;
    //   console.log(localStorage.getItem(data.exchange +'secondStatusCheck'), secondStatusCheck);
    //   showCountdown(parseInt(localStorage.getItem(data.exchange +'countdownSec')))
    // } else {
    //   setSecondStatusCheck(false) ;

    //   secondStatusCheck = false;
    // }
    let data = uuidv4();

    // handleAuthOtpModalShow();
  }, []);

  const generateUUID = () => {
    Fingerprint2.get(OPTIONS_FOR_FINGERPRINT, (components) => {
      const values = components.map((component) => component.value);
      const hash = Fingerprint2.x64hash128(values.join(""), 31);
      const existingDeviceId = localStorage.getItem("deviceId");

      if (
        !existingDeviceId ||
        existingDeviceId === "null" ||
        existingDeviceId === "undefined" ||
        existingDeviceId === ""
      ) {
        localStorage.setItem("deviceId", hash);
        setDeviceId(hash);
        Cookies.set("deviceID", hash, { expires: 60 }); // 60 days
      }

      console.log("Device ID:", hash);
      return hash;
    });
  };

  // function showCountdown(i) {
  //   showCountdownVar = setInterval(function () {
  //     // console.log('time', i)

  //     countdownSec = i;
  //     localStorage.setItem(data.exchange +'countdownSec', countdownSec)
  //     i-- || clearInterval(showCountdownVar) || newF();  //if i is 0, then stop the interval
  //     // console.log(i)

  //   }.bind(this), 1000)

  // }
  // function newF() {
  //   secondStatusCheck = false;
  //   localStorage.setItem(data.exchange +'secondStatusCheck', 'false');

  // }

  function redirectToAuthentication(captcha, sessionId) {
    // if (
    //   loginEmail == "demo@hashcashconsultants.org" ||
    //   loginEmail == "demo@virsymx.com"
    // ) {
    //   setIsLoading(true);

    //   onAuthModalSubmit("12345678");
    // } else {
    let payload = {
      email: loginEmail,
      password: loginPassword,
      gRecaptchaResponse: captcha,
      sessionId: sessionId,
      brokerId: localStorage.getItem("BROKERID_Domain"),
    };

    axios({
      url: WEBSERVICE + "user/checkMfaStatus",
      method: "POST",
      headers: { "content-Type": "application/json" },
      // Attaching the form data
      data: JSON.stringify(payload),
    })
      // Handle the response from backend here
      .then((res) => {
        var data = res?.data;
        if (data?.error?.error_data == "1") {
          showToast("error", data?.error?.error_msg);
        } else if (data?.error?.error_data == "2") {
          showToast("error", data?.error?.error_msg);
        } else {
          if (data?.userResult?.userTag == 6) {
            setIsLoading(true);

            onAuthModalSubmit("12345678");
          } else {
            setUserPhoneCountryCodeUsingForSendingSms(
              data?.userResult?.countryCode
            );

            localStorage.setItem(
              "twoFactorAuth",
              data?.userResult?.twoFactorAuth
            );
            localStorage.setItem(
              "userSmsAuthStatus",
              data?.userResult?.phoneValidation
            );

            localStorage.setItem("user_name", data?.userResult?.firstName);
            localStorage.setItem("first_name", data?.userResult?.firstName);
            localStorage.setItem("last_name", data?.userResult?.lastName);
            localStorage.setItem("middle_name", data?.userResult?.middleName);
            localStorage.setItem("user_id", data?.userResult?.userId);
            localStorage.setItem("userId", data?.userResult?.userId);
            localStorage.setItem("email", data?.userResult?.email);
            localStorage.setItem("profile_pic", data?.userResult?.profilePic);
            localStorage.setItem("check_id_verification_status", "true");
            const pair = data?.defaultAssetPair || data?.userResult?.defaultAssetPair;
            if (pair) {
              handleDefaultAssetPair(pair, true);
            } else {
              localStorage.setItem("selected_currency", "btc");
              localStorage.setItem("buying_crypto_asset", "btc");
              localStorage.setItem("O_buying_crypto_asset", "btc");
              localStorage.setItem("selling_crypto_asset", "usdt");
              localStorage.setItem("O_selling_crypto_asset", "usdt");
            }
            localStorage.setItem(
              "UserTiretype",
              data?.userResult?.userTierType
            );
            localStorage.setItem("exist2FaKey", data?.userResult?.exist2FaKey);
            if (
              localStorage.getItem("BROKERID") === data?.userResult?.brokerId
            ) {
              console.log("");
            } else {
              // console.log("brokerId--> 4", data?.userResult?.brokerId);
              localStorage.setItem("BROKERID", data?.userResult?.brokerId);
            }

            /*** Automatically send verification code to email */
            if (copyEmail !== loginEmail) {
              sendVerificationCodeMail();
            } else {
              handleAuthOtpModalShow();
            }

            //Show hide GA field in popup
            if (data?.userResult?.twoFactorAuth == 1) {
              setIsGoogleAuthEnable(true);
            } else {
              setIsGoogleAuthEnable(false);
            }
            //Show hide phone verification field in popup
            if (data?.userResult?.phoneValidation == 1) {
              setIsPhoneVerificationEnable(true);

              /*** Automatically send verification code to phone number */
              if (copyPhoneEmail !== loginEmail) {
                handleSendOtpThroughSms();
              }
            } else {
              setIsPhoneVerificationEnable(false);
            }
            setUserPhoneUsingForSendingSms(data?.userResult?.phone);
          }
          //  modalService.open(myModalAuth, { centered: true, backdrop: false, keyboard: false });
        }
      });

    // }
    // sendVerificationCodeMail();

    /* Get Code button for sms auth popup */
  }
  useEffect(() => {
    handleSendOtpThroughSms();
  }, [userPhoneUsingForSendingSms, userPhoneCountryCodeUsingForSendingSms]);

  const handleSendOtpThroughSms = async () => {
    if (userPhoneUsingForSendingSms) {
      let payload = {
        phone: userPhoneUsingForSendingSms,
        countryCode: userPhoneCountryCodeUsingForSendingSms,
      };

      try {
        await sendSmartMobileOtp(payload, "login");
        startPhoneOtpCountdown();
        setCopyPhoneEmail(loginEmail);
      } catch (error) {
        console.error("Login SMS OTP Error:", error);
      }
    }
  };

  function sendVerificationCodeMail() {
    // disabledSpan = true;

    startCountdown();

    var userObj = {};
    userObj["email"] = loginEmail;

    axios({
      url: WEBSERVICE + "user/SendOtp/login",
      method: "POST",
      headers: { "content-Type": "application/json" },
      // Attaching the form data
      data: JSON.stringify(userObj),
    })
      // Handle the response from backend here
      .then((response) => {
        var result = response.data;

        if (result.error.error_data == 0) {
          showToast("success", "OTP Sent to your email id");
          handleAuthOtpModalShow();
          setCopyEmail(loginEmail);
          setSecondStatusCheck(true);
        } else {
          showToast("error", result.error.error_msg);
        }
      });

    // userdtlApi = http.post<any>(data.WEBSERVICE + '/user/SendOtp/login', userJsonString, { headers: { 'Content-Type': 'application/json' } })
    //   .subscribe(response => {

    //     console.log('mail sent', response)
    //     if (response.error.error_data == 0) {
    //       data.alert('OTP has been sent to your mail id', 'success'); secondStatusCheck = true
    //       disabledSpan = false;

    //       localStorage.setItem(data.exchange +'secondStatusCheck', 'true');
    //       countdownSec = data.timeIntervalForEmail;
    //       localStorage.setItem(data.exchange +'countdownSec', countdownSec)
    //       showCountdown(countdownSec);

    //     }
    //     else {
    //       disabledSpan = false;
    //       data.alert(response.error.error_msg, 'danger')

    //       setTimeout(() => {
    //       modalService.dismissAll()

    //       }, 250);

    //     }

    //   })
  }

  const MaskEmail = ({ email }) => {
    try {
      const maskEmail = (email) => {
        const atIndex = email.indexOf("@");
        if (atIndex > 3) {
          return (
            email.slice(0, 3) + "*".repeat(atIndex - 3) + email.slice(atIndex)
          );
        }
        return email;
      };

      return (
        <Typography>
          Please enter the email code from {maskEmail(email)}
        </Typography>
      );
    } catch {}
  };

  const setLoginData = async (data, sixthParam) => {
    const accessToken = data.token;
    const uuid = data.userResult.uuid;

    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("uuid", uuid);

    const exchangeTokenExpiry = new Date();
    exchangeTokenExpiry.setMonth(exchangeTokenExpiry.getMonth() + 12);
    document.cookie = `exchange_token=${accessToken};expires=${exchangeTokenExpiry};domain=.paybito.com;path=/`;

    const userObj = { userId: data.userResult.userId, uuid };
    const userJsonString = JSON.stringify(userObj);

    const response = await axios.post(
      `${WEBSERVICE}user/GetUserDetails`,
      userJsonString,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${accessToken}`,
        },
      }
    );

    const dataRecheck = response.data;
    if (dataRecheck.error.error_data === 0) {
      const userDetails = dataRecheck.userResult;
      const myDate = new Date();
      myDate.setMonth(myDate.getMonth() + 12);

      document.cookie = `Username=${userDetails.firstName};expires=${myDate};domain=.paybito.com;path=/`;
      document.cookie = `userId=${userDetails.userId};expires=${myDate};domain=.paybito.com;path=/`;
      document.cookie = `ssecca=${accessToken};expires=${myDate};domain=.paybito.com;path=/`;

      localStorage.setItem("user_name", userDetails.firstName);
      localStorage.setItem("email", userDetails.email);
      localStorage.setItem("profile_pic", userDetails.profilePic);
      localStorage.setItem(
        "tier2SubmissionDate",
        userDetails.tier2SubmitDate || ""
      );
      localStorage.setItem(
        "tier3SubmissionDate",
        userDetails.tier3SubmitDate || ""
      );
      localStorage.setItem(
        "tier2ApprovedDate",
        userDetails.tier2ApprovedDate || ""
      );
      localStorage.setItem(
        "tier3ApprovedDate",
        userDetails.tier3ApprovedDate || ""
      );

      localStorage.setItem("user_name", userDetails.firstName);
      localStorage.setItem("first_name", userDetails.firstName);
      localStorage.setItem("last_name", userDetails.lastName);
      localStorage.setItem("middle_name", userDetails.middleName);
      localStorage.setItem("user_id", userDetails.userId);
      localStorage.setItem("userId", userDetails.userId);
      // document.cookie = cookieName1 + "=" + userDetails.userId + ";expires=" + myDate + ";domain=.paybito.com;path=/";
      localStorage.setItem("email", userDetails.email);
      localStorage.setItem("profile_pic", userDetails.profilePic);
      localStorage.setItem("check_id_verification_status", "true");
      const pair = dataRecheck?.defaultAssetPair || dataRecheck?.userResult?.defaultAssetPair;
      if (pair) {
        handleDefaultAssetPair(pair, true);
      } else {
        localStorage.setItem("selected_currency", "btc");
        localStorage.setItem("buying_crypto_asset", "btc");
        localStorage.setItem("O_buying_crypto_asset", "btc");
        localStorage.setItem("selling_crypto_asset", "usdt");
        localStorage.setItem("O_selling_crypto_asset", "usdt");
      }
      localStorage.setItem("UserTiretype", userDetails.userTierType);
      localStorage.setItem("exist2FaKey", userDetails.exist2FaKey);
      localStorage.setItem("userCountry", userDetails.country);
      if (localStorage.getItem("BROKERID") === userDetails.brokerId) {
        console.log("");
      } else {
        // console.log("brokerId--> 5", userDetails.brokerId);
        localStorage.setItem("BROKERID", userDetails.brokerId);
      }

      // if(window.location.origin+'/' == this.data.demoBrokerDomain){

      // }
      // else{

      //   this.data.BROKERID = userDetails.brokerId;
      // }

      // Check if redirecting from payments
      const storedCallFrom = localStorage.getItem("callFrom");
      if (storedCallFrom === "payments") {
        const storedInvoiceData = localStorage.getItem("invoicePayData");
        localStorage.removeItem("callFrom");
        if (storedInvoiceData) {
          const invoiceData = JSON.parse(storedInvoiceData);
          const params = new URLSearchParams(invoiceData).toString();
          navigate(`/my-wallet?${params}`);
          return;
        }
      }

      // Check for stored loginFor parameter
      const storedLoginFor = localStorage.getItem("loginFor");
      const redirectParam = sixthParam || storedLoginFor;

      if (redirectParam) {
        handleSixthParam(redirectParam, userDetails.userId, uuid, accessToken);
        // Clear the stored parameter after use
        localStorage.removeItem("loginFor");
      } else {
        if (userDetails.userTierType == 2 || userDetails.userTierType == 3) {
          await routeTolocation(userDetails);
        } else {
          navigate("/identity-verification");
        }
      }
    } else {
      showToast("error", "Unable to fetch user details.");
    }
    // } catch (error) {
    //   console.error("Login error:", error);
    //   alert("Server Error Occurred");
    //   setLoginButtonEnabled(true);
    //   setDisableLoginButton(false);
    // }
  };

  const routeTolocation = async (userDetails) => {
    try {
      const tier2ApprovedDate = new Date(userDetails.tier2ApprovedDate || "");
      const tier3ApprovedDate = new Date(userDetails.tier3ApprovedDate || "");
      const diffDays =
        tier2ApprovedDate &&
        Math.ceil(
          Math.abs(currentDate - tier2ApprovedDate) / (1000 * 60 * 60 * 24)
        );
      const diffDayst3 =
        tier3ApprovedDate &&
        Math.ceil(
          Math.abs(currentDate - tier3ApprovedDate) / (1000 * 60 * 60 * 24)
        );

      if (userDetails?.userTierType == 2 || userDetails?.userTierType == 3) {
        // this.route.navigateByUrl('/dashboard');
        navigateBasedOnPermission(userDetails);
      } else if (
        (new Date(userDetails.created) <
          new Date(userDetails?.reKycCheckDate) &&
          !userDetails.tier2SubmitDate) ||
        (tier2ApprovedDate && diffDays >= 365)
      ) {
        navigate("/identity-verification");
      } else if (
        userDetails.userDocsStatus === "1" &&
        ((new Date(userDetails.created) <
          new Date(userDetails.reKycCheckDate) &&
          !userDetails.tier3SubmitDate) ||
          diffDayst3 >= 365)
      ) {
        navigate("/identity-verification");
      } else {
        navigateBasedOnPermission(userDetails);
      }
      // window.location.reload();
    } catch (error) {
      console.error("Error in routing:", error);
    }
  };

  // const routeTolocation = async (userDetails) => {
  //   const tier2ApprovedDate = new Date(userDetails.tier2ApprovedDate || "");
  //   const tier3ApprovedDate = new Date(userDetails.tier3ApprovedDate || "");
  //   let diffTime = null;
  //   let diffTimet3 = null;
  //   if (tier2ApprovedDate != null) {
  //     diffTime = Math.abs(new Date(currentDate) - new Date(tier2ApprovedDate));
  //   }

  //   if (tier3ApprovedDate != null) {
  //     diffTimet3 = Math.abs(
  //       new Date(currentDate) - new Date(tier3ApprovedDate)
  //     );
  //   }

  //   const tier2datediff =
  //     new Date(userDetails?.createdDate) <
  //     new Date(userDetails?.reKycCheckDate);

  //   if (
  //     (tier2datediff && !userDetails?.tier2SubmissionDate) ||
  //     (tier2ApprovedDate && diffTime >= 365)
  //   ) {
  //     navigate("/identity-verification");
  //   } else {
  //     localStorage.setItem("tierTwoReKycPopup", "false");

  //     if (
  //       userDetails?.userDocsStatus === "1" &&
  //       ((tier2datediff && !userDetails?.tier3SubmissionDate) ||
  //         diffTimet3 >= 365)
  //     ) {
  //       navigate("/identity-verification");
  //     } else {
  //       if (!userDetails.isSpot) {
  //         if (!userDetails.isFutures) {
  //           if (!userDetails.isOptions) {
  //             navigate("/profile-details");
  //           } else {
  //             navigate("/options");
  //           }
  //         } else {
  //           navigate("/futures");
  //         }
  //       } else {
  //         navigate("/spot");
  //       }
  //     }
  //   }
  // };

  const navigateBasedOnPermission = (userDetails) => {
    const redirectAfterLogin = localStorage.getItem("redirectAfterLogin");
    if (redirectAfterLogin) {
      localStorage.removeItem("redirectAfterLogin");
      navigate(redirectAfterLogin, { replace: true });
      return;
    }
    const { isSpot, isFutures, isOptions } = userDetails;
    if (isSpot === 0) {
      if (isFutures === 0) {
        if (isOptions === 0) {
          navigate("/profile-details");
        } else {
          navigate("/options");
        }
      } else {
        navigate("/futures");
      }
    } else {
      navigate("/spot");
    }
  };

  const handleSixthParam = (sixthParam, userId, uuid, accessToken) => {
    if (sixthParam === "nft") {
      const jsonStr = JSON.stringify({ userId, uuid, token: accessToken });
      const str = btoa(jsonStr);
      window.location.href = `https://www.paybito.com/nft-marketplace/session/${str}`;
    } else if (sixthParam === "data-deletion") {
      navigate("/settings");
    } else if (sixthParam === "appstore" || sixthParam === "app-store") {
      window.location.href = window.location.origin + "/app-store/";
    } else if (sixthParam.startsWith("app-store/") || sixthParam.startsWith("appstore/")) {
      const targetPath = sixthParam.startsWith("app-store/")
        ? sixthParam
        : "app-store/" + sixthParam.substring("appstore/".length);
      window.location.href = window.location.origin + "/" + targetPath;
    } else if (sixthParam === "ico-merchant") {
      setTimeout(() => {
        const obj = {
          userId: userId,
          uuid: uuid,
          token: accessToken
        };
        const jsonStr = JSON.stringify(obj);
        const str = btoa(jsonStr);
        window.location.href = `https://ico-contract-owner.hashcashconsultants.com/session.html?obj=${str}`;
      }, 1000);
    } else {
      navigate("/identity-verification");
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  useEffect(() => {
    checkAndEnableConfirmButton();
  }, [emailOtp, phoneOtp, gaOtp]);

  const checkAndEnableConfirmButton = () => {
    const emailOtpLength = emailOtp?.length || 0;
    const phoneOtpLength = phoneOtp?.length || 0;
    const twoFactorOtpLength = gaOtp?.length || 0;

    if (
      !isPhoneVerificationEnable &&
      !isGoogleAuthEnable &&
      emailOtpLength === 8
    ) {
      authSubmit(onAuthModalSubmit)();
      // setDisableConfirmButton(true);
    } else if (
      isPhoneVerificationEnable &&
      !isGoogleAuthEnable &&
      emailOtpLength === 8 &&
      phoneOtpLength === 8
    ) {
      authSubmit(onAuthModalSubmit)();
      // setDisableConfirmButton(true);
    } else if (
      isPhoneVerificationEnable &&
      isGoogleAuthEnable &&
      emailOtpLength === 8 &&
      phoneOtpLength === 8 &&
      twoFactorOtpLength === 6
    ) {
      authSubmit(onAuthModalSubmit)();
      // setDisableConfirmButton(true);
    } else if (
      !isPhoneVerificationEnable &&
      isGoogleAuthEnable &&
      emailOtpLength === 8 &&
      twoFactorOtpLength === 6
    ) {
      authSubmit(onAuthModalSubmit)();
      // setDisableConfirmButton(true);
    } else {
      // setDisableConfirmButton(false);
    }
  };

  const handleVerifyClick = () => {
    setResendVerifyButtonErrorMessage("");

    const resendVerifyMailObj = {
      email: loginEmail,

      latitude: deviceDetails?.latitude,
      longitude: deviceDetails?.longitude,
      ipAddress: deviceDetails?.ip,
      location: deviceDetails?.country_name,
      deviceId:
        localStorage.getItem("deviceId") === "" ||
        localStorage.getItem("deviceId") === "undefined"
          ? localStorage.getItem("uuid")?.toString()
          : localStorage.getItem("deviceId"),
      deviceType: isMobile
        ? "mobile"
        : isTablet
        ? "tablet"
        : isDesktop
        ? "Desktop browser"
        : "unknown",
      browser: `${browserName} ${browserVersion}`,
    };

    axios
      .post(
        "https://accounts.paybito.com/api/user/resendDeviceVerificationMail",
        resendVerifyMailObj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result.error.error_data !== 0) {
          showToast("error", result.error.error_msg);
        } else {
          showToast("success", result.error.error_msg);
          let timeLeft = 120;
          setCounter(timeLeft);
          setShowCounter(true);
          const id = setInterval(() => {
            timeLeft -= 1;
            setCounter(timeLeft);
            if (timeLeft <= 0) {
              clearInterval(id);
              setShowCounter(false);
            }
          }, 1000);
          setIntervalId(id);
        }
      })
      .catch((error) => {
        alert("Error: Failed to send verification email");
        console.error(error);
      });
  };

  const callFcmTokenRegister = async (token, uuid) => {
    console.log("in calling fcm token");

    const userObj = {
      platform: "WEB",
      uuid: uuid,
      token: localStorage.getItem("fcmToken"),
      audience: "TRADER",
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}notification/updateFCMToken`,
        JSON.stringify(userObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + token,
          },
        }
      );

      console.log("FCM token registered:", response.data);
    } catch (error) {
      console.error("Error registering FCM token:", error);
    }
  };

  // console.log("email and password", watch("emailId"), watch("password"));

  return (
    <>
      {isBrokerLoaded ? (
        <Box
          sx={{
            ...backgroundStyle,
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            px: { xs: 2, sm: 4, md: 5 },
            py: { xs: 2, sm: 2, md: 2 },
          }}
        >
          <Box maxWidth="sm" sx={{ width: "100%", m: "auto" }}>
            <Paper
              elevation={6}
              sx={{
                mx: "auto",

                width: "100%",
                // mb: 2,
                p: { xs: 2.5, sm: 4 },
                borderRadius: 4,
                backgroundColor: "#ffffff",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
              }}
            >
              <Typography
                textAlign="center"
                gutterBottom
                // sx={{ color: "#1a1a1a", fontWeight: 600 }}
                sx={{
                  fontWeight: "bold",
                  fontSize: "40px !important",
                  mb: 2,
                  color: "#999898",
                }}
              >
                Login to {brokerBasicInfo?.exchange || "Your Broker"}
              </Typography>

              <form onSubmit={loginSubmit(onSubmit)}>
                {/* Email */}
                <TextField
                  label="Email Address"
                  fullWidth
                  margin="normal"
                  className="black-autofill"
                  {...loginRegister("emailId", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Enter a valid email address",
                    },
                  })}
                  error={!!loginErrors.emailId}
                  helperText={loginErrors.emailId?.message}
                  // onChange={(e) => setLoginEmail(e.target.value)}
                  InputLabelProps={{
                    sx: {
                      color: "#333",
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      mt: 0.5,
                    },
                  }}
                  sx={{
                    mt: 2,
                    input: { color: "#333" },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "#ccc",
                      },
                      "&:hover fieldset": {
                        borderColor: "#888",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1976d2",
                      },
                    },
                  }}
                />

                {/* Password */}
                <TextField
                  label="Password"
                  type={passwordVisible ? "text" : "password"}
                  fullWidth
                  margin="normal"
                  className="black-autofill"
                  {...loginRegister("password", {
                    required: "Password is required",
                  })}
                  error={!!loginErrors.password}
                  helperText={loginErrors.password?.message}
                  // onChange={(e) => setLoginPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={togglePasswordVisibility}
                          edge="end"
                        >
                          {passwordVisible ? (
                            <VisibilityIcon sx={{ color: "#1976d2" }} />
                          ) : (
                            <VisibilityOffIcon sx={{ color: "#1976d2" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "#333",
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },
                  }}
                  sx={{
                    mt: 2,
                    input: { color: "#333" },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "#ccc",
                      },
                      "&:hover fieldset": {
                        borderColor: "#888",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1976d2",
                      },
                    },
                  }}
                />
                {resendVerifyButtonErrorMessage && (
                  <Box display="flex" mt={3} justifyContent="center">
                    <Typography variant="body2" mt={1} color="error">
                      {resendVerifyButtonErrorMessage}
                    </Typography>
                  </Box>
                )}

                {showUnverifiedMsg && (
                  <>
                    <Box display="flex" justifyContent="space-between" mt={3}>
                      <Typography variant="body2" mt={1} sx={{ color: "#333" }}>
                        Resend device verification mail
                      </Typography>

                      {!showCounter ? (
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => handleVerifyClick()}
                        >
                          Resend
                        </Button>
                      ) : (
                        <Button variant="outlined">Sent</Button>
                      )}
                    </Box>
                  </>
                )}

                {showCounter && (
                  <Typography
                    id="countermsg"
                    variant="body2"
                    color="textSecondary"
                    textAlign="center"
                    mt={2}
                  >
                    Resend in {counter} seconds
                  </Typography>
                )}

                {/* Submit Button */}
                <Button
                  variant="contained"
                  type="submit"
                  fullWidth
                  sx={{
                    mt: 4,
                    // backgroundColor: "#1976d2",
                    background: frontPageButtonColor,
                    color: "#fff",
                    fontWeight: 600,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#155fa0",
                    },
                  }}
                >
                  {isLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Log in"
                  )}
                </Button>

                {/* Links */}
                <Box display="flex" justifyContent="space-between" mt={3}>
                  <Link
                    href="/forget-password"
                    underline="none"
                    sx={{ fontSize: 14, color: "#1976d2", cursor: "pointer" }}
                  >
                    Reset Password?
                  </Link>
                  <Typography variant="body2" sx={{ color: "#333" }}>
                    Not registered yet?{" "}
                    <Link
                      href="/signup"
                      style={{
                        color: "#1976d2",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      Register
                    </Link>
                  </Typography>
                </Box>
              </form>
              {brokerSocialLogin == true ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  sx={{ marginTop: "0px", width: "100%" }}
                >
                  <SocialLogin purpose="your-purpose-value" />
                </Box>
              ) : (
                ""
              )}
              <PaybitoCaptcha ref={captchaRef} />
            </Paper>
          </Box>
        </Box>
      ) : (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="#f5f5f5"
        >
          <CircularProgress />
        </Box>
      )}

      <Dialog
        open={authOtpModalShow}
        onClose={handleAuthOtpModalClose}
        maxWidth="xs"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 3,
            backgroundColor: "#fff",
            color: "#000",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            color: "#000",
          }}
        >
          <span>Security Authentication</span>
          <IconButton onClick={handleAuthOtpModalClose}>
            <CloseIcon sx={{ color: "#1976d2" }} />
          </IconButton>
        </DialogTitle>

        {/* <button className="close-button" onClick={handleAuthOtpModalClose}>
          <span className="close-icon-wallet">&times;</span>
        </button> */}

        <DialogContent>
          <Typography variant="body2" gutterBottom>
            <MaskEmail email={loginEmail} />
          </Typography>

          <form onSubmit={authSubmit(onAuthModalSubmit)}>
            <TextField
              fullWidth
              type="text" // change here
              autoComplete="off"
              inputMode="numeric" // for mobile keypad
              label="E-mail verification code"
              variant="outlined"
              margin="normal"
              value={emailOtp}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                setEmailOtp(value);
              }}
              InputLabelProps={{
                sx: {
                  color: "#333",
                  "&.Mui-focused": {
                    color: "#1976d2",
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  mt: 0.5,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {countdown === 0 && (
                      <Typography
                        variant="body2"
                        sx={{
                          cursor: "pointer",
                          color: "primary.main",
                          whiteSpace: "nowrap",
                        }}
                        onClick={sendVerificationCodeMail}
                      >
                        Get code
                      </Typography>
                    )}
                  </InputAdornment>
                ),
              }}
              sx={{
                mt: 2,
                input: { color: "#333" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  "& fieldset": {
                    borderColor: "#ccc",
                  },
                  "&:hover fieldset": {
                    borderColor: "#888",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1976d2",
                  },
                },
              }}
            />

            {countdown !== 0 && (
              <Typography variant="body2" sx={{ color: "green", mb: 2 }}>
                Resend in {countdown} seconds
              </Typography>
            )}

            {isPhoneVerificationEnable && (
              <>
                <Typography sx={{ pt: 1, color: "black" }}>
                  Input OTP from your registered phone number
                </Typography>
                <TextField
                  fullWidth
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  label="Phone OTP"
                  variant="outlined"
                  margin="normal"
                  value={phoneOtp}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 8);
                    setPhoneOtp(value);
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "#333",
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      mt: 0.5,
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {showGetCodeButtonInSmsOtpPopup === 0 && (
                          <Typography
                            variant="body2"
                            sx={{
                              cursor: "pointer",
                              color: "primary.main",
                              whiteSpace: "nowrap",
                            }}
                            onClick={handleSendOtpThroughSms}
                          >
                            Get code
                          </Typography>
                        )}
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    mt: 2,
                    input: { color: "#333" },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "#ccc",
                      },
                      "&:hover fieldset": {
                        borderColor: "#888",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1976d2",
                      },
                    },
                  }}
                />
                {showGetCodeButtonInSmsOtpPopup !== 0 && (
                  <Typography variant="body2" sx={{ color: "green", mb: 2 }}>
                    Resend in {showGetCodeButtonInSmsOtpPopup} seconds
                  </Typography>
                )}
              </>
            )}

            {isGoogleAuthEnable && (
              <>
                <Typography sx={{ pt: 1, color: "black" }}>
                  Input OTP from your Google Authenticator
                </Typography>
                <TextField
                  fullWidth
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  label="Google Authenticator code"
                  variant="outlined"
                  margin="normal"
                  value={gaOtp}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setGaOtp(value);
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "#333",
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      mt: 0.5,
                    },
                  }}
                  sx={{
                    mt: 2,
                    input: { color: "#333" },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      "& fieldset": {
                        borderColor: "#ccc",
                      },
                      "&:hover fieldset": {
                        borderColor: "#888",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1976d2",
                      },
                    },
                  }}
                />
              </>
            )}

            {emailOtp && (
              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={countdown === 0 || emailOtp?.length === 8}
                sx={{
                  mt: 3,
                  backgroundColor: frontPageButtonColor || "primary.main",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: frontPageButtonColor || "primary.dark",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#ccc", // visible grey
                    color: "#666", // visible text color
                  },
                }}
              >
                Confirm
              </Button>
            )}
          </form>
        </DialogContent>
      </Dialog>

      {/* <Snackbar
        open={open}
        autoHideDuration={1200}
        onClose={handleClose}
        message="This Snackbar will be dismissed in 5 seconds."
      /> */}

      {/* <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">Bootstrap</strong>
            <small>11 mins ago</small>
          </Toast.Header>
          <Toast.Body>Woohoo, you're reading this text in a Toast!</Toast.Body>
        </Toast> */}
    </>
  );
}
